﻿import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router, NavigationEnd } from '@angular/router';
import { UtilService } from 'src/app/_services/util.service';


@Component({
    selector: 'app-tabla',
    templateUrl: 'tabla.component.html'
})
export class TablaComponent implements OnInit {

    editing = {};
    temp = {};
    rows: any;
    page = 10;
    pageSize = [5, 10, 25, 50];
    nextId = -1;
    loading = false;

    @Input()
    allData: any;

    @Input()
    tabla: Tabla;

    @Input()
    categoriaDeporte: any;

    @Input()
    postaPorCategoria: boolean = false;

    @Input()
    individual: boolean = true;

    @Input()
    max: number = 10;

    navigationSubscription;

    @ViewChild('mydatatable') table: DatatableComponent;

    constructor(private restService: RestService, private router: Router, private utilService: UtilService) {
        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initalise the component
            if (e instanceof NavigationEnd && this.tabla) {
                if (!this.loading && !this.tabla.externalData) {
                    this.loadAll();
                }
            }
        });
    }

    ngOnInit() {
        if (this.tabla.externalData) {
            this.rows = JSON.parse(JSON.stringify(this.allData));
        } else {
            this.loadAll();
        }
    }


    private loadAll() {
        this.loading = true;
        this.restService.getAll(this.tabla.endPoint).subscribe(data => {
            this.rows = data;
            this.allData = JSON.parse(JSON.stringify(data));
        });
    }

    updateValue(event, cell, rowIndex) {
        this.set(this.temp[rowIndex], cell, event.target.value);
    }

    updateObject(value, cell, rowIndex) {
        this.set(this.temp[rowIndex], cell, this.rows[cell][this.indexByID(this.rows[cell], +value)]);
    }

    set(schema: any, path: string, value: any) {
        const pList = path.split('.');
        const len = pList.length;
        for (let i = 0; i < len - 1; i++) {
            const elem = pList[i];
            if (!schema[elem]) {
                schema[elem] = {};
            }
            schema = schema[elem];
        }

        schema[pList[len - 1]] = value;
    }

    get(schema: any, path: string): any {
        if (path.indexOf(' ') > -1) {
            let rest = '';
            path.split(' ').forEach(prop => {
                rest = rest + this.get(schema, prop) + ' ';
            });
            return rest;
        } else {
            const pList = path.split('.');
            const len = pList.length;
            for (let i = 0; i < len - 1; i++) {
                const elem = pList[i];
                if (!schema[elem]) {
                    schema[elem] = {}
                }
                schema = schema[elem];
            }
            return schema[pList[len - 1]];
        }
    }

    editar(row: any) {
        if (this.tabla.editable && !this.editing[row.id]) {
            this.temp[row.id] = JSON.parse(JSON.stringify(row));
            this.editing[row.id] = true;
        }
    }

    cancelar(row: any) {
        this.editing[row.id] = false;
        if (this.rows.data) {
            this.rows.data = [...this.rows.data];
        } else {
            this.rows = [...this.rows];
        }
    }

    date(value): any {
        return new Date(value).getTimezoneOffset();
    }


    guardar(row: any) {
        this.restService.post(this.tabla.endPoint, this.temp[row.id])
            .subscribe(
                data => {
                    this.editing[row.id] = false;
                    const index = this.indexByID(this.rows.data ? this.rows.data : this.rows, row.id);
                    if (this.rows.data) {
                        this.rows.data[index] = data;
                        this.rows.data = [...this.rows.data];
                    } else {
                        this.rows[index] = data;
                        this.rows = [...this.rows];
                    }
                });
    }

    eliminar(row: any) {
        const index = this.indexByID(this.rows.data ? this.rows.data : this.rows, row.id);
        if (index > -1) {
            if (this.rows.data) {
                this.rows.data.splice(index, 1);
                this.rows.data = [...this.rows.data];
            } else {
                this.rows.splice(index, 1);
                this.rows = [...this.rows];
            }
        }


    }

    indexByID(array, id: number) {
        for (let x = 0; x < array.length; x++) {
            if (array[x].id === id) {
                return x;
            }
        }
        return -1;
    }


    updateFilter(event, col: Columna) {
        const val = event.target.value.toLowerCase();

        let todos = this.allData.data ? JSON.parse(JSON.stringify(this.allData.data)) : JSON.parse(JSON.stringify(this.allData));

        const self = this;
        col.filtro = val;

        this.tabla.columnas.forEach(cc => {
            if (cc.filtro && cc.filtro.toString().trim().length > 0) {
                // filter our data
                todos = todos.filter(function (d) {
                    let elem = self.get(d, cc.prop);
                    if (cc.cell && elem) {
                        elem = elem[cc.cell];
                    }
                    if (elem) {
                        return elem.toString().toLowerCase().indexOf(cc.filtro) !== -1 || !cc.filtro;
                    } else {
                        return !cc.filtro;
                    }
                });
            }
        });

        // update the rows
        if (this.rows.data) {
            this.rows.data = todos;
        } else {
            this.rows = todos;
        }

        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
    }


    addElement() {
        const nuevo: any = {};
        this.tabla.columnas.forEach(col => {
            if (col.cell) {
                let tmp = nuevo;
                col.prop.split('.').forEach(p => {
                    if (!tmp[p]) {
                        tmp[p] = { id: -1 };
                    }
                    tmp = tmp[p];
                });

            } else {
                nuevo[col.prop] = col.prop === 'anio' ? (new Date()).getFullYear() : '';
            }
        });

        nuevo.id = this.nextId;


        if (this.rows.paramCategoriaDeporte) {
            nuevo.categoriaDeporte = this.rows.paramCategoriaDeporte;
            nuevo.sexo = this.rows.paramSexo;
            nuevo.anio = this.rows.paramAnio;
        }
        this.nextId = this.nextId - 1;
        if (this.rows.data) {
            this.rows.data = [...[nuevo].concat(this.rows.data)];
        } else {
            this.rows = [...[nuevo].concat(this.rows)];
        }
        this.temp[nuevo.id] = nuevo;
        this.editing[nuevo.id] = true;

    }

    isTime(row: any): boolean {
        if (this.rows.paramCategoriaDeporte) {
            return this.rows.paramCategoriaDeporte.deporte.medicion === 'TIEMPO';
        }
        return row.categoriaDeporte.deporte.medicion === 'TIEMPO';
    }

    sort(a, b): number {

        if (a === null || typeof a === 'undefined') {
            a = 0;
        }
        if (b === null || typeof b === 'undefined') {
            b = 0;
        }
        if (a instanceof Date && b instanceof Date) {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
        } else if (isNaN(parseFloat(a)) || !isFinite(a) || (isNaN(parseFloat(b)) || !isFinite(b))) {
            // Convert to string in case of a=0 or b=0
            a = String(a.nombre ? a.nombre : a);
            b = String(b.nombre ? b.nombre : b);
            // Isn't a number so lowercase the string to properly compare
            if (a.toLowerCase() < b.toLowerCase()) {
                return -1;
            }
            if (a.toLowerCase() > b.toLowerCase()) {
                return 1;
            }
        } else {
            // Parse strings as numbers to compare properly
            if (parseFloat(a) < parseFloat(b)) {
                return -1;
            }
            if (parseFloat(a) > parseFloat(b)) {
                return 1;
            }
        }

        // equal each other
        return 0;
    }

    getSexo(value, path, row) {
        if (((this.categoriaDeporte && this.categoriaDeporte.deporte && this.categoriaDeporte.deporte.id === 5)
            || (row.categoriaDeporte && row.categoriaDeporte.deporte && row.categoriaDeporte.deporte.id === 5))
            && !this.postaPorCategoria) {
            if (this.categoriaDeporte) {
                return this.utilService.getGrado(this.categoriaDeporte.categoria, row.sexo);
            } else {
                return this.utilService.getGrado(row.categoriaDeporte.categoria, row.sexo);
            }
        } else {
            if (value && path) {
                return this.get(value, path);
            }
        }
    }

    title(col: Columna): string {
        if (col.name == 'Valor' &&  this.allData.paramCategoriaDeporte && this.allData.paramCategoriaDeporte.deporte && this.allData.paramCategoriaDeporte.deporte.medicion == "TIEMPO") {
            return "min : seg . mil";
        } else {
            return col.name;
        }
    }
}


export class Tabla {
    titulo: string;
    endPoint: string;
    editable: boolean;
    nuevo?: boolean;
    columnas: Columna[];
    hideHeader?: boolean;
    hideFilter?: boolean;
    externalData?: boolean;
}

export class Columna {
    name: string;
    prop: string;
    cell?: string;
    editable: boolean;
    resizeable: boolean;
    sortable: boolean;
    width: number;
    filtro?: string;
    icon?: boolean;
    pattern?: boolean;
    hidden?: boolean;
    casa?: boolean;
    sexo?: boolean;
}

